// extracted by mini-css-extract-plugin
export var container = "_c9-0";
export var popoverContent = "_c9-1";
export var tosLink = "_c9-2";